import { render, staticRenderFns } from "./octree.vue?vue&type=template&id=5b8e70ae&"
import script from "./octree.vue?vue&type=script&lang=ts&"
export * from "./octree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports